module.exports = __webpack_public_path__ + "img/vac.ea18a743.svg";